import _extends from "@babel/runtime/helpers/extends";
export var tenantToCustomerCulture = function tenantToCustomerCulture(tenantCulture, selectedCultureCode) {
  if (selectedCultureCode === void 0) {
    selectedCultureCode = tenantCulture.DefaultCultureCode;
  }

  var customerCulture = tenantCulture.Cultures.find(function (culture) {
    return culture.CultureCode === selectedCultureCode;
  });

  if (!customerCulture && tenantCulture.Cultures.length > 0) {
    var _tenantCulture$Cultur = tenantCulture.Cultures;
    customerCulture = _tenantCulture$Cultur[0];
  }

  if (!customerCulture) {
    throw new Error('No Culture found!');
  }

  var financialSet = tenantCulture.FinancialSets.find(function (set) {
    return set.FinancialSetId === tenantCulture.DefaultFinancialSetId;
  });

  if (!financialSet && tenantCulture.FinancialSets.length > 0) {
    var _tenantCulture$Financ = tenantCulture.FinancialSets;
    financialSet = _tenantCulture$Financ[0];
  }

  if (!financialSet) {
    throw new Error('No FinancialSet found!');
  }

  return _extends({}, customerCulture, {
    TimeZone: tenantCulture.TimeZone,
    FinancialSet: financialSet
  });
};